import { PropsWithChildren } from "react";
import styles from "./Highlight.module.css";

export function RepHighlight(props: PropsWithChildren<{ enable?: boolean }>) {
    const { children, enable } = props;
    return <div className={enable ? styles.rep : undefined}>{children}</div>;
}

export function SearchHighlight(props: PropsWithChildren<{}>) {
    const { children } = props;
    return <div className={styles.search}>{children}</div>;
}

export function InterpretHighlight(props: PropsWithChildren<{}>) {
    const { children } = props;
    return <div className={styles.interpret}>{children}</div>;
}
